import { useState, useEffect } from "react";
import {
  Card,
  CardActions,
  Collapse,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const CollapsePromotion = ({ children, title }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const timeoutOpen = setTimeout(() => {
      setOpen(true);
    }, 500);
    return () => {
      clearTimeout(timeoutOpen);
    };
  }, []);

  return (
    <>
      <Card style={{ marginTop: "15px" }}>
        <CardActions style={{ padding: "12px 24px" }}>
          <Grid container justifyContent="flex-start">
            <Typography>{title} </Typography>
          </Grid>
          <Grid container justifyContent="flex-end">
            <IconButton onClick={() => setOpen((old) => !old)}>
              {open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
            </IconButton>
          </Grid>
        </CardActions>
        <Divider />
        <Collapse in={open}>{children}</Collapse>
      </Card>
    </>
  );
};

export default CollapsePromotion;
